export default "__VITE_ASSET__aWM4r3GZ__"